import uuid from 'uuid';

export const UPLOAD_FILE: string = 'UPLOAD_FILE';
export const UPLOADING_FILE: string = 'UPLOADING_FILE';
export const PROCESSING_FILE: string = 'PROCESSING_FILE';
export const UPLOAD_FILE_SUCCESS: string = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE: string = 'UPLOAD_FILE_FAILURE';
export const CROP_RESOURCE: string = 'CROP_RESOURCE';
export const CANCEL_PENDING: string = 'CANCEL_PENDING';

const pendingUpload = file => ({
  token: uuid(),
  name: file.name,
  file,
});

const runningUpload = upload => ({
  ...upload,
  state: 'uploading',
  file: undefined,
});

export const uploadFile = (folder, file) => ({
  type: UPLOAD_FILE,
  folder,
  upload: pendingUpload(file),
});

export const uploadingFile = (folder, upload) => ({
  type: UPLOADING_FILE,
  folder,
  upload: runningUpload(upload),
});

export const uploadFileSuccess = (folder, upload, response) => ({
  type: UPLOAD_FILE_SUCCESS,
  folder,
  upload,
  response,
});

export const uploadFileFailure = (folder, upload, error) => ({
  type: UPLOAD_FILE_FAILURE,
  folder,
  upload,
  error,
});

export const cropResource = (
  folder: BucketFolder,
  resource: BucketResource,
  crop: CropConfig
): Action => ({
  type: CROP_RESOURCE,
  folder,
  resource,
  crop,
  upload: {
    token: uuid(),
    name: resource.name,
  },
});

export const cancelPending = () => ({
  type: CANCEL_PENDING,
});



// WEBPACK FOOTER //
// ./src/modules/bucket/actions/uploads.js